import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation, useMatch } from "react-router-dom";
import axios from "axios";

import Header from "./Header";
import Header2 from "./Header2";
import Footer from "./Footer";
import Home from "./Home";
import Mainproductpage from "./Mainproductpage";
import Maincategorypage from "./Maincategory";
import Maintagpage from "./Maintagpage";
import Mainstate from "./mainstate";
import Contact from "./Contact";
import Disclaimer from "./Disclaimer";
import Refundpolicy from "./Refundpolicy";
import Privacypolicy from "./Privacypolicy";
import Termsconditions from "./Termsconditions";
import Searchbar from "./Searchbar";
import Scrolltop from "./Scrolltop";
import Thankyou from "./Thankyou";
import Marketarea from "./marketarea/india";
import APACstateandcity from "./marketarea/APACstateandcity";
import EUstateandcity from "./marketarea/EUstateandcity";
import Middleeaststateandcity from "./marketarea/Middleeaststateandcity";
import Namericastateandcity from "./marketarea/Namericastateandcity";
import Samericastateandcity from "./marketarea/Samericastateandcity";
import Africa from "./marketarea/africa";
import Indiandistrict from "./marketarea/indiandistrict";
import Kerword from "./kerword";

// CSS
import "./assets/css/open-iconic-bootstrap.min.css";
import "./assets/css/animate.css";
import "./assets/css/magnific-popup.css";
import "./assets/css/aos.css";
import "./assets/css/ionicons.min.css";
import "./assets/css/bootstrap-datepicker.css";
import "./assets/css/jquery.timepicker.css";
import "./assets/css/flaticon.css";
import "./assets/css/icomoon.css";
import "./assets/css/style.css";

/** Conditional Layout Wrapper */
function Layout({ children }) {
  const location = useLocation();
  const matchLocationRoot = useMatch("/:location");
  const matchLocationDeep = useMatch("/:location/*");
  const isLocationBased = Boolean(matchLocationRoot || matchLocationDeep);

  return (
    <>
      {isLocationBased ? <Header2 /> : <Header />}
      {children}
      <Footer />
    </>
  );
}

function App() {
  const [dynamicRoutes, setDynamicRoutes] = useState([]);

  useEffect(() => {
    const fetchAllRoutes = async () => {
      try {
        // 1) Fetch all category slugs
        const catUrl =
          "https://phpstack-1434504-6130285.cloudwaysapps.com/api/categories?fields[0]=slug&publicationState=live&sort=slug:asc&pagination[pageSize]=100";
        const catRes = await axios.get(catUrl);
        const categories = catRes?.data?.data ?? [];

        // 2) Fetch all article slugs
        const artUrl =
          "https://phpstack-1434504-6130285.cloudwaysapps.com/api/master-blogs?fields[0]=slug&publicationState=live&sort=slug:asc&pagination[pageSize]=100";
        const artRes = await axios.get(artUrl);
        const articles = artRes?.data?.data ?? [];

        // 3) Fetch all tag slugs (✅ Added for Maintagpage routing)
        const tagUrl =
          "https://phpstack-1434504-6130285.cloudwaysapps.com/api/tags?fields[0]=slug&publicationState=live&sort=slug:asc&pagination[pageSize]=100";
        const tagRes = await axios.get(tagUrl);
        const tags = tagRes?.data?.data ?? [];

        const out = [];

        // ✅ Build CATEGORY routes: /blog/:location/<categorySlug>  → Maincategorypage
        for (const c of categories) {
          const categorySlug = c?.slug || c?.attributes?.slug;
          if (!categorySlug) continue;

          out.push({
            path: `/blog/:location/${categorySlug}`,
            element: <Maincategorypage />,
          });
        }

        // ✅ Build ARTICLE routes: /blog/:location/<articleSlug> → Mainproductpage
        for (const a of articles) {
          const articleSlug = a?.slug || a?.attributes?.slug;
          if (!articleSlug) continue;

          out.push({
            path: `/blog/:location/${articleSlug}`,
            element: <Mainproductpage />,
          });
        }

        // ✅ Build TAG routes: /blog/:location/tag/<tagSlug> → Maintagpage
        // Keeping a distinct "tag" segment to avoid conflicts with article/category slugs
        for (const t of tags) {
          const tagSlug = t?.slug || t?.attributes?.slug;
          if (!tagSlug) continue;

          out.push({
            path: `/blog/:location/${tagSlug}`,
            element: <Maintagpage />,
          });
        }

        // Deduplicate by path
        const seen = new Set();
        const dedup = out.filter((r) => !seen.has(r.path) && seen.add(r.path));
        setDynamicRoutes(dedup);
      } catch (err) {
        console.error("dynamic routes fetch error:", err);
      }
    };

    fetchAllRoutes();
  }, []);

  return (
    <Router>
      <Scrolltop />
      <Layout>
        <main>
          <Routes>
            {/* Static Routes */}
            <Route path="/blog" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/refund-policy" element={<Refundpolicy />} />
            <Route path="/terms-conditions" element={<Termsconditions />} />
            <Route path="/privacy-policy" element={<Privacypolicy />} />
            <Route path="/Thankyou" element={<Thankyou />} />
            <Route path="/Kerword" element={<Kerword />} />

            {/* Market area pages */}
            <Route path="/blog/ma" element={<Marketarea />} />
            <Route path="/marketarea/1" element={<APACstateandcity />} />
            <Route path="/marketarea/2" element={<EUstateandcity />} />
            <Route path="/marketarea/3" element={<Middleeaststateandcity />} />
            <Route path="/marketarea/4" element={<Namericastateandcity />} />
            <Route path="/marketarea/5" element={<Samericastateandcity />} />
            <Route path="/marketarea/6" element={<Africa />} />
            <Route path="/marketarea/7" element={<Indiandistrict />} />

            {/* ✅ DYNAMIC LOCATION & CATEGORY/TAG/ARTICLE ROUTES */}
            {/* Location landing */}
            {/* <Route path="/:location" element={<Mainstate />} /> */}
            <Route path="/blog/:location" element={<Mainstate />} />

            {/* ✅ Specific TAG route (placed before generic slug routes to avoid conflicts) */}
            <Route path="/blog/:location/tag/:tagSlug" element={<Maintagpage />} />

            {/* Keep ARTICLE route BEFORE CATEGORY route */}
            <Route path="/blog/:location/:articleSlug" element={<Mainproductpage />} />
            <Route path="/blog/:location/:categorySlug" element={<Maincategorypage />} />

            {/* Keeping your existing generic Maintagpage param route as-is (not removed) */}
            <Route path="/blog/:location/:maintagpage" element={<Maintagpage />} />

            {/* Inject dynamic routes (categories + articles + tags) */}
            {dynamicRoutes.map(({ path, element }) => (
              <Route key={path} path={path} element={element} />
            ))}

            <Route path="/search" element={<Searchbar />} />
            <Route path="/:location/search" element={<Searchbar />} />
            <Route path="/blog/:location/search" element={<Searchbar />} />
          </Routes>
        </main>
      </Layout>
    </Router>
  );
}

export default App;
